import { locationIdFormat } from "@redotech/redo-inventory-id";
import * as z from "zod";

import { StationStep } from "./create-work-order-station";

const WorkOrderStation_ = z.object({
  id: z.string(),
  name: z.string(),
  locationId: z.string().nullable(),
  steps: z.array(StationStep),
  queueCount: z.number().int(),
  queueItemCount: z.number().int().nullish(),
});
export const WorkOrderStation: z.ZodType<WorkOrderStation> = WorkOrderStation_;
export interface WorkOrderStation extends z.infer<typeof WorkOrderStation_> {}

export const getWorkOrderStations = {
  name: "getWorkOrderStations" as const,
  input: z.object({ locationId: locationIdFormat.schema.optional() }),
  output: z.object({ stations: z.array(WorkOrderStation) }),
};
